import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./User.scss";
import { Button, Tag, Form, message, Popconfirm, Table, Switch } from "antd";
// import Table from '../../utils/Table'
import userActions from "../../redux/user/actions";
import {
  EditOutlined,
  DeleteFilled,
  CheckCircleOutlined,
} from "@ant-design/icons";
import UserModal from "./components/UserFormModel";
import moment from "moment";
import SearchBar from "../../utils/Searchbar";
import decryptedModulesData from "../../utils/decryptedModules";

const columns = [
  {
    title: "#",
    dataIndex: "key",
    key: "key",
  },
  {
    title: "NAME",
    dataIndex: "name",
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: "EMAIL",
    dataIndex: "email",
    sorter: (a, b) => a.email.localeCompare(b.email),
  },
  {
    title: "ROLE",
    dataIndex: "role",
    // sorter: (a, b) => a.role.localeCompare(b.role)
  },
  {
    title: "CREATED DATE",
    dataIndex: "created_date",
    sorter: (a, b) => new Date(a.created_date) - new Date(b.created_date),
  },
  {
    title: "PASSWORD EXPIRY",
    dataIndex: "expiry_date",
    sorter: (a, b) => new Date(a.created_date) - new Date(b.created_date),
  },
  {
    title: "STATUS",
    dataIndex: "status",
  },
  {
    title: "ACTIONS",
    dataIndex: "action",
  },
];

const {
  getUserData,
  getRoles,
  getModules,
  addUser,
  editUser,
  deleteUser,
  openForm,
  userReset,
  userResetMessage,
  userStatusChange,
} = userActions;
function User() {
  const { modules: userPermissions,roleId,role } = decryptedModulesData();
  const dispatch = useDispatch();
  const [UserForm] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const {
    userData,
    loading,
    totalData,
    rolesData,
    modulesData,
    error,
    show,
    buttonLoading,
  } = useSelector((state) => state.userReducer);
  const sucessMessage = useSelector((state) => state.userReducer.message);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [userId, setUserId] = useState();
  const [selectedModules, setSelectedModules] = useState([]);
  const [fromTitle, setfromTitle] = useState("");
  const [editFlag, setEditFlag] = useState(false);
  const [formButton, setformButton] = useState("");
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
  });

  const profileData = useSelector((state) => state.authReducer.profileData);

  useEffect(() => {
    dispatch(getUserData(0, 10, ""));
    dispatch(getModules());
  }, [dispatch]);

  useEffect(() => {
    if (sucessMessage !== null && sucessMessage !== undefined) {
      success(sucessMessage);
    }
    if (error !== null && error !== undefined) {
      errorHandle(error);
    }
  }, [sucessMessage, error]);

  const success = (text) => {
    const hide = messageApi.open({
      type: "success",
      content: text,
    });
    setTimeout(hide, 4000);
    dispatch(userResetMessage());
  };
  const errorHandle = (text) => {
    const hide = messageApi.open({
      type: "error",
      content: text,
    });
    setTimeout(hide, 4000);
    dispatch(userResetMessage());
  };

  const showModal = () => {
    dispatch(getModules());
    dispatch(getRoles());
    setfromTitle("ADD USER");
    setformButton("Submit");
    setEditFlag(false);
    dispatch(openForm());
    UserForm.resetFields();
    setSelectedModules([]);
    setUserId(null); // Reset user ID
  };

  const handleEdit = (record) => {
    dispatch(getModules());
    dispatch(getRoles());
    setEditFlag(true);
    setUserId(record._id);
    setfromTitle("UPDATE USER");
    setformButton("Update");

    // Clear previous state first
    UserForm.resetFields();
    setSelectedModules([]);

    const permissions = Array.isArray(record?.permissions)
      ? record?.permissions
      : [];

    // Map database permissions (with moduleId) to UI permissions (with module and key) using modulesData
    const mappedPermissions = permissions.map((perm) => {
      const matchedModule = modulesData?.find((m) => m._id === perm.moduleId);
      return {
        ...perm,
        module: matchedModule ? matchedModule.moduleName : "",
        key: matchedModule ? matchedModule.key : "",
      };
    }).filter(p => p.module);

    UserForm.setFieldsValue({
      name: record.name,
      role: record.roleId,
      email: record.email,
      permissions: mappedPermissions?.map((perm) => perm.module),
      ...mappedPermissions?.reduce((acc, curr) => {
        acc[`${curr.module.replace(/\s+/g, "_")}_permissions`] = [
          curr.read ? "read" : "",
          curr.create ? "create" : "",
          curr.update ? "update" : "",
          curr.delete ? "delete" : "",
        ].filter(Boolean);
        return acc;
      }, {}),
    });
    dispatch(openForm());
    setSelectedModules(
      mappedPermissions?.map((perm) => ({
        module: perm.module,
        key: perm.key,
        moduleId: perm.moduleId,
      }))
    );
  };

  const handleCancel = () => {
    dispatch(userReset());
    UserForm.resetFields();
    setSelectedModules([]);
  };

  const handleSubmit = (values) => {
    const selectedRole = rolesData.find((role) => role.roleId === values.role);
    const isMasterAdmin = selectedRole?.role
      .toLowerCase()
      .includes("master admin");

    const modules = selectedModules.map((item) => {
      const hasManualChanges =
        values[`${item.module.replace(/\s+/g, "_")}_permissions`] !==
          undefined &&
        values[`${item.module.replace(/\s+/g, "_")}_permissions`]?.length > 0;

      const matchedModule = modulesData?.find((m) => m.moduleName.toLowerCase() === item.module.toLowerCase());
      const moduleId = item.moduleId || (matchedModule ? matchedModule._id : "");

      if (isMasterAdmin && !hasManualChanges) {
        // Master admin + no manual changes = use default full permissions
        return {
          moduleId,
          read:
            values[`${item.module.replace(/\s+/g, "_")}_permissions`]?.includes(
              "read",
            ) || true,
          create:
            values[`${item.module.replace(/\s+/g, "_")}_permissions`]?.includes(
              "create",
            ) || true,
          update:
            values[`${item.module.replace(/\s+/g, "_")}_permissions`]?.includes(
              "update",
            ) || true,
          delete:
            values[`${item.module.replace(/\s+/g, "_")}_permissions`]?.includes(
              "delete",
            ) || true,
        };
      } else {
        // For other roles, use the form values
        return {
          moduleId,
          read:
            values[`${item.module.replace(/\s+/g, "_")}_permissions`]?.includes(
              "read",
            ) || false,
          create:
            values[`${item.module.replace(/\s+/g, "_")}_permissions`]?.includes(
              "create",
            ) || false,
          update:
            values[`${item.module.replace(/\s+/g, "_")}_permissions`]?.includes(
              "update",
            ) || false,
          delete:
            values[`${item.module.replace(/\s+/g, "_")}_permissions`]?.includes(
              "delete",
            ) || false,
        };
      }
    });

    if (editFlag) {
      const payload = {
        role: values.role,
        permissions: modules,
        status: "Active",
      };
      // debugger
      dispatch(editUser(userId, payload));
    } else {
      const payload = {
        name: values.name,
        email: values.email,
        password: values.password,
        role: selectedRole.role,
        permissions: modules,
      };
      debugger
      // dispatch(addUser(payload));
    }
  };

  const handleModuleChangenew = ({ module, key }) => {
    const moduleLower = module.toLowerCase();
    const formKey = `${moduleLower.replace(/\s+/g, "_")}_permissions`;

    const exists = selectedModules.some(
      (item) => item.module.toLowerCase() === moduleLower,
    );

    if (exists) {
      // REMOVE MODULE
      setSelectedModules((prev) =>
        prev.filter((item) => item.module.toLowerCase() !== moduleLower),
      );

      // Remove permissions from form
      UserForm.setFieldsValue({
        [formKey]: [],
      });
    } else {
      // ADD MODULE
      const matchedModule = modulesData?.find((m) => m.moduleName.toLowerCase() === moduleLower);
      const moduleId = matchedModule ? matchedModule._id : "";
      setSelectedModules((prev) => [...prev, { module, key, moduleId }]);

      // Default permission = READ
      UserForm.setFieldsValue({
        [formKey]: ["read"],
      });
    }
  };

  const dataSource =
    userData &&
    userData?.length > 0 &&
    userData.map((user, index) => {
      return {
        key: (tableParams.current - 1) * tableParams.pageSize + index + 1,
        name: user.name,
        email: user.email,
        role: <Tag color="cyan">{user.role}</Tag>,
        created_date: moment(new Date(user?.createdAt)).format("MM/DD/YYYY"),
        expiry_date: moment(new Date(user?.createdAt))
          .add(90, "days")
          ?.format("MM/DD/YYYY"),
        status: (
          <Tag
            color={user.status === "Active" ? "green" : "red"}
            className="draft"
          >
            {user.status === "Active" ? "Active" : "Deactive"}
          </Tag>
        ),
        action: (
          <>
            {/* Edit button (only if update permission) */}
            {Array.isArray(userPermissions) &&
              profileData?.userId !== user?._id &&
              userPermissions?.find(
                (item) => item?.module?.toLowerCase() === "users",
              )?.update &&
              (role?.toLowerCase() === "super admin" ||
                (role?.toLowerCase() === "master admin" &&
                  user?.role?.toLowerCase() !== "super admin") ||
                (role?.toLowerCase() !== "super admin" &&
                  role?.toLowerCase() !== "master admin")) && (
                <Button className={`border-0 px-0`}>
                  <EditOutlined
                    style={{
                      fontSize: "18px",
                    }}
                    onClick={() => {
                      handleEdit(user);
                    }}
                  />
                </Button>
              )}

            {Array.isArray(userPermissions) &&
              profileData?.userId !== user?._id &&
              userPermissions?.find(
                (item) => item?.module?.toLowerCase() === "users",
              )?.update &&
              (role?.toLowerCase() === "super admin" ||
                (role?.toLowerCase() === "master admin" &&
                  user?.role?.toLowerCase() !== "super admin") ||
                (role?.toLowerCase() !== "super admin" &&
                  role?.toLowerCase() !== "master admin")) && (
                <Button className={`border-0 px-0`}>
                  {user.status === "Active" ? (
                    <Popconfirm
                      title="Are you sure to deactivate this user?"
                      okText="Yes"
                      cancelText="No"
                      placement="topRight"
                      onConfirm={() => {
                        dispatch(deleteUser(user._id));
                      }}
                    >
                      <DeleteFilled
                        style={{
                          fontSize: "18px",
                          color: "#e92121",
                          marginLeft: "10px",
                        }}
                      />
                    </Popconfirm>
                  ) : (
                    <Popconfirm
                      title="Are you sure to activate this user?"
                      okText="Yes"
                      cancelText="No"
                      placement="topRight"
                      onConfirm={() => {
                        dispatch(userStatusChange(user));
                      }}
                    >
                      <CheckCircleOutlined
                        style={{
                          fontSize: "18px",
                          color: "#2e830b",
                          marginLeft: "10px",
                        }}
                      />
                    </Popconfirm>
                  )}
                </Button>
              )}
          </>
        ),
      };
    });

  let timeoutId;
  const handleFilterChange = (e) => {
    e.preventDefault();
    const value = e.target.value;

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      if (value.length > 1) {
        dispatch(getUserData(0, 20, value));
      }
      if (value.length < 1) {
        dispatch(getUserData(0, 20));
      }
    }, 1000);
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    const { current, pageSize } = pagination;
    setTableParams({ current, pageSize });
    dispatch(getUserData((current - 1) * pageSize, pageSize));
  };

  return (
    <>
      {contextHolder}
      <div className="mainContain">
        <h1 className="transaction">Users</h1>
        <div className="d-flex justify-content-between align-items-center">
          <SearchBar onChange={handleFilterChange} />
          <Button
            type="primary"
            size="large"
            disabled={
              !(
                Array.isArray(userPermissions) &&
              userPermissions?.find(
                  (item) => item?.module?.toLowerCase() === "users",
                )?.create
              )
            }
            onClick={() => {
              const hasCreate =
                Array.isArray(userPermissions) &&
                userPermissions?.find(
                  (item) => item?.module?.toLowerCase() === "users",
                )?.create;
              if (hasCreate) {
                showModal();
              }
            }}
            style={{
              backgroundColor: "#073763",
              borderColor: "#073763",
              color: "white",
              opacity: !(
                Array.isArray(userPermissions) &&
                userPermissions?.find(
                  (item) => item?.module?.toLowerCase() === "users",
                )?.create
              )
                ? 0.5
                : 1,
              cursor: !(
                Array.isArray(userPermissions) &&
                userPermissions?.find(
                  (item) => item?.module?.toLowerCase() === "users",
                )?.create
              )
                ? "not-allowed"
                : "pointer",
            }}
          >
            Add User
          </Button>
        </div>
        <div className="mt-3">
          <Table
            columns={columns}
            dataSource={dataSource}
            loading={loading}
            pagination={{
              disabled:
                loading || tableParams.pageSize > totalData ? true : false,
              total: totalData,
              pageSize: tableParams.pageSize,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "50"],
            }}
            onChange={handleTableChange}
          />
        </div>
      </div>
      <UserModal
        fromTitle={fromTitle}
        open={show}
        buttonLoading={buttonLoading}
        confirmLoading={confirmLoading}
        handleCancel={handleCancel}
        handleSubmit={handleSubmit}
        editFlag={editFlag}
        formButton={formButton}
        UserForm={UserForm}
        selectedModules={selectedModules}
        setSelectedModules={setSelectedModules}
        handleModuleChangenew={handleModuleChangenew}
        roles={rolesData}
        modules={modulesData}
        loading={loading}
        loggedInUser={profileData}
      />
    </>
  );
}

export default User;
